import { isBlueBolt, isGlobalworth } from 'config'
import { ResourceType } from 'shared/types'

export const getAvailableResourceTypes = (): ResourceType[] =>
  (Object.values(ResourceType) as ResourceType[]).filter(type => {
    if (isBlueBolt && type === ResourceType.Locker) return false
    if (
      isGlobalworth &&
      (type === ResourceType.Other || type === ResourceType.Sauna)
    )
      return false
    return true
  })
